import React, { FC, PropsWithChildren, useCallback } from 'react';
import fp from 'lodash/fp';
import VisibilitySensor from 'react-visibility-sensor';
import { Skeleton } from '@mui/material';

import { Stack, useMobile, useMediaSwitch, BoxProps, Box } from 'Modules/ui3';

import { NewsPreview, NewsPreviewProps } from '../NewsPreview';
import { SlideBaseProps } from '../Slider/types';


export const NewsSlideContainer: FC<PropsWithChildren<BoxProps>> = ({
    children, ...props
}) => {
    const isMobile = useMobile();
    return (
        <Box
            p={isMobile ? 6 : 8}
            whiteSpace='normal'
            width='100%'
            minHeight={isMobile ? '260px' : '324px'}
            height='100%'
            bgcolor='#F4F3F2'
            borderRadius={useMediaSwitch(12, 10, 8)}
            {...props}
        >
            {children}
        </Box>
    );
};

export type NewsSlideProps = SlideBaseProps<NewsPreviewProps[]> & {
    needShow?: () => void;
}


export const NewsSlide: FC<NewsSlideProps> = ({ data, needShow }) => {
    const onVisible = useCallback(isVisible => isVisible && needShow && needShow(), [needShow]);
    const isMobile = useMobile();
    return (
        <Stack spacing={2} height='100%' width={isMobile ? '328px' : '400px'}>
            {data.map((news, idx) => fp.isEmpty(news) ? (
                <VisibilitySensor key={`slideIndex_${idx}`} onChange={onVisible}>
                    <NewsSlideContainer>
                        <Skeleton width='70%' />
                        <Skeleton width='100%' />
                        <Skeleton width='100%' />
                    </NewsSlideContainer>
                </VisibilitySensor>
            ) : (
                <NewsSlideContainer
                    key={fp.getOr(idx, 'Id', news)}
                    flex={1}
                    sx={{
                        cursor: 'pointer',
                        '& *': {
                            userSelect: 'none',
                            webkitUserSelect: 'none',
                            khtmlUserSelect: 'none',
                            mozUserSelect: 'none',
                            msUserSelect: 'none',
                        },
                    }}
                >
                    <NewsPreview {...news} />
                </NewsSlideContainer>
            ))}
        </Stack>
    );
};
